export const RESERVED_SLUGS = new Set([
  'api',
  'admin',
  'login',
  'signup',
  'logout',
  'onboarding',
  'invite',
  'invites',
  'portal',
  'dsync-portal',
  'well-known',
  'oauth',
  'idp',
  'error',
  'settings',
  'billing',
  'docs',
  'help',
  'new',
  'orbitid',
  'instatus-admin'
])

export const slugify = (value: string) =>
  value
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 48)

export const isValidSlug = (slug: string) =>
  /^[a-z0-9][a-z0-9-]{0,46}[a-z0-9]$/.test(slug) && !RESERVED_SLUGS.has(slug)

export const suffixedSlug = (slug: string, suffix: string) => `${slug.slice(0, 48 - suffix.length - 1).replace(/-+$/, '')}-${suffix}`

export const slugCandidates = (name: string, suffixes: string[]) => {
  const base = slugify(name)
  const candidates = isValidSlug(base) ? [base] : []
  const stem = isValidSlug(base) ? base : 'team'
  return [...candidates, ...suffixes.map((suffix) => suffixedSlug(stem, suffix))]
}
